import { useTranslation } from 'react-i18next'

import styles from './goal.module.scss'

interface Props {
    title: string
    amount: string
    validationError: string
    handleTitleChange: (title: string) => void
    handleAmountChange: (amount: string) => void
}

const Goal = ({
    title,
    amount,
    validationError,
    handleTitleChange,
    handleAmountChange
}: Props) => {
    const { t } = useTranslation()
    return (
        <div className={styles.goal}>
            <div className={styles.header}>
                <input
                    type='text'
                    value={title}
                    name='goalTitle'
                    id='goalTitle'
                    placeholder={`${t('goal')}...`}
                    maxLength={25}
                    onKeyPress={e => {
                        const target = e.target as HTMLInputElement
                        if (amount && target.value.length >= 25) {
                            e.preventDefault()
                        }
                    }}
                    onChange={e => {
                        handleTitleChange(e.target.value)
                    }}
                />
            </div>
            <div className={styles.content}>
                <div className={styles.inputGroup}>
                    <input
                        value={amount}
                        type='number'
                        name='goalAmount'
                        id='goalAmount'
                        placeholder={amount ? '' : t('setGoalAmount')}
                        max={250}
                        onChange={e => {
                            handleAmountChange(e.target.value)
                        }}
                        onBlur={e => {
                            const value = e.target.value.replace(/^0+(?=\d)/, '')
                            handleAmountChange(value)
                        }}
                    />

                    {amount && <div className={styles.dollar}>$</div>}

                </div>

                {validationError && (
                    <div className={styles.error}>{validationError}</div>
                )}
            </div>
        </div>
    )
}

export default Goal
